var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menuNotification"},[_c('img',{staticClass:"menuNotification__ico",attrs:{"data-auto":"emptyTableLogoClock","src":require("./../assets/check-mark.svg")}}),_vm._v("\n\n  Спасибо за вашу обратную связь\n")])
}]

export { render, staticRenderFns }